<template>
  <div>
    <v-card
      style="width:100%;"
      class="d-flex justify-center"
      v-if="!showMobileView"
    >
      <v-layout
        class="d-flex justify-center align-center pr-4"
        style="height:80px; width: 100%;"
      >
        <div class="d-flex align-center pl-5" style="width:100%; height:80px;">
          <h4
            style="color:gray; padding-right:4px;"
            @click="goBack()"
            class="go-back"
            id="rental-recon-breadcrumb"
          >
            Rental Reconciliation >
          </h4>
          <h4 id="rental-recon-id-breadcrumb">{{ details.uuid }}</h4>
        </div>
      </v-layout>
    </v-card>
    <v-row class="d-flex flex-wrap justify-center ma-0">
      <div :style="divStyle" class="mx-4">
        <div :class="divClass" style="width:100%;">
          <rental-agreement />
          <device-status />
        </div>
        <div style="width:100%;" :class="divClass">
          <reconciliation-notes />
        </div>
      </div>
      <accessory-checkin />
    </v-row>
    <div class="d-flex justify-center">
      <submit-report />
    </div>
    <locations v-if="sessionLocations" :_deviceLocations="sessionLocations" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ReconciliationDetailData from '@/mixins/ReconciliationDetailData';
import { MobileView } from '@/mixins';
import RentalAgreement from '@/components/reconciliation/RentalAgreement.vue';
import DeviceStatus from '@/components/reconciliation/DeviceStatus.vue';
import ReconciliationNotes from '@/components/reconciliation/ReconciliationNotes.vue';
import AccessoryCheckin from '@/components/reconciliation/AccessoryCheckin.vue';
import SubmitReport from '@/components/reconciliation/SubmitReport.vue';
import Locations from '@/components/app/Locations.vue';
import router from '../router';

export default {
  mixins: [ReconciliationDetailData, MobileView],
  components: {
    RentalAgreement,
    DeviceStatus,
    ReconciliationNotes,
    AccessoryCheckin,
    Locations,
    SubmitReport,
  },
  computed: {
    ...mapGetters({
      currentClient: 'account/getCurrentClient',
      sessionLocations: 'reconciliationDetails/getSessionLocations',
      _clientIsSet: 'account/getClientIsSet',
    }),
    divStyle() {
      if (this.showMobileView) {
        return 'overflow:hidden; width:100%;';
      }
      return 'width:60%; overflow:hidden; height:fit-content;';
    },
    divClass() {
      if (this.showMobileView) {
        return 'd-flex flex-column';
      }
      return 'd-flex';
    },
  },
  methods: {
    ...mapActions({
      _acquireData: 'reconciliationDetails/acquireDetails',
    }),
    goBack() {
      router.push(
        `/${this.currentClient.client_name
          .toLowerCase()
          .replace(/\s/g, '')}/reconciliation`,
      );
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this._clientIsSet) {
      this._acquireData(this.$route.params.id);
    }
  },
  watch: {
    _clientIsSet() {
      if (this._clientIsSet) {
        this._acquireData(this.$route.params.id);
      }
    },
  },
};
</script>

<style>
.go-back:hover {
  cursor: pointer;
}
</style>
